import { FC } from 'react'

import { ButtonSizes, ButtonVariants } from '@inno-ui/button'
import { EmptyState, Illustrations } from '@inno-ui/empty-state'

import styles from './ErrorPage.module.scss'
import { ErrorPageProps } from './ErrorPage.types'

const reloadCurrentContext = () => window.location.reload()

const ErrorPage: FC<ErrorPageProps> = ({
  title,
  secondLine,
  description,
  retryBtnLabel,
  onRetry = reloadCurrentContext,
  illustration = Illustrations.Roadblock
}) => {
  return (
    <div className={styles.wrapper}>
      <EmptyState
        title={title}
        secondLine={secondLine}
        description={description}
        illustration={illustration}
        titleMaxWidth='560px'
        secondLineMaxWidth='520px'
        descriptionMaxWidth='560px'
        actions={[
          {
            label: retryBtnLabel,
            size: ButtonSizes.M,
            variant: ButtonVariants.Dark,
            onClick: onRetry
          }
        ]}
      />
    </div>
  )
}

export { ErrorPage }
